export default __webpack_public_path__ + "static/media/appLogo.10f6b056.png";